import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import CustomerReport from './layouts/CustomerReport'
import SalesRepReport from './layouts/SalesRepReport'
import SalesRepTypeReport from './layouts/SalesRepTypeReport'

const ShippingReportPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Profitability',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const ShippingReportPage = () => {
  return (
    <Navigation
      baseUrl='/analytics/profitability/shipping-report'
      breadcrumbs={ShippingReportPageCrumbs}
      pageTitle='Shipping Report'
      navigationData={[
        {
          key: 'customer-report',
          label: 'Customer Report',
          component: <CustomerReport />,
        },
        {
          key: 'sales-rep-report',
          label: 'Sales Representative',
          component: <SalesRepReport />,
        },
        {
          key: 'sales-rep-type-report',
          label: 'Sales Representative Type',
          component: <SalesRepTypeReport />,
        },
      ]}
    />
  )
}

export default ShippingReportPage
